import { render, staticRenderFns } from "./swpFire.vue?vue&type=template&id=32c89b90"
import script from "./swpFire.vue?vue&type=script&lang=js"
export * from "./swpFire.vue?vue&type=script&lang=js"
import style0 from "./swpFire.vue?vue&type=style&index=0&id=32c89b90&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c89b90')) {
      api.createRecord('32c89b90', component.options)
    } else {
      api.reload('32c89b90', component.options)
    }
    module.hot.accept("./swpFire.vue?vue&type=template&id=32c89b90", function () {
      api.rerender('32c89b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpFire.vue"
export default component.exports